module.exports = __webpack_public_path__ + "static/robot-7482ddbc7ad22cfbac14eec482862e79.png";